export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Shop by <span className="text-accent-500">Category</span>
          </h2>
          <p className="text-foreground-500 text-sm max-w-md mx-auto">
            Browse our curated categories and find the best deals across every product type
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-4 mb-4">
          <a
            href="https://kaspreadsheet.com/category-911-Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="relative w-full lg:w-1/2 h-[320px] md:h-[420px] rounded-2xl overflow-hidden group cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20fashion%20sneakers%20on%20white%20marble%20surface%2C%20soft%20natural%20daylight%2C%20simple%20elegant%20composition%2C%20warm%20neutral%20background%2C%20editorial%20style%2C%20high%20detail%2C%20shallow%20depth%20of%20field&width=800&height=1000&seq=cat-01&orientation=portrait"
              alt="Shoes"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <span className="text-white text-xl md:text-2xl font-heading font-semibold">Shoes</span>
            </div>
          </a>

          <div className="flex flex-col gap-4 w-full lg:w-1/2">
            <a
              href="https://kaspreadsheet.com/search-912/name/Shoes.html"
              target="_blank"
              rel="noopener nofollow"
              className="relative h-[152px] md:h-[202px] rounded-2xl overflow-hidden group cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20fashion%20photography%20of%20soft%20hoodie%20sweater%20on%20light%20cream%20background%2C%20gentle%20cozy%20atmosphere%2C%20clean%20studio%20lighting%2C%20textured%20fabric%20detail%2C%20warm%20neutral%20tones%2C%20high%20end%20lifestyle%20catalog%20style&width=800&height=500&seq=cat-02&orientation=landscape"
                alt="Hoodies / Sweaters"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="text-white text-lg md:text-xl font-heading font-semibold">Hoodies / Sweaters</span>
              </div>
            </a>
            <a
              href="https://kaspreadsheet.com/search-913/name/Shoes.html"
              target="_blank"
              rel="noopener nofollow"
              className="relative h-[152px] md:h-[202px] rounded-2xl overflow-hidden group cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Fresh%20minimal%20product%20photography%20of%20cotton%20t-shirt%20on%20light%20airy%20background%2C%20soft%20morning%20sunlight%2C%20clean%20simple%20aesthetic%2C%20warm%20white%20tones%2C%20editorial%20fashion%20flatlay%2C%20gentle%20shadows%2C%20premium%20lifestyle%20feel&width=800&height=500&seq=cat-03&orientation=landscape"
                alt="T-Shirts"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="text-white text-lg md:text-xl font-heading font-semibold">T-Shirts</span>
              </div>
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
          <a
            href="https://kaspreadsheet.com/search-914/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative h-[160px] rounded-xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20stylish%20jacket%20on%20neutral%20beige%20backdrop%2C%20soft%20studio%20lighting%2C%20clean%20composition%2C%20warm%20earthy%20undertones%2C%20high%20fashion%20editorial%20feel%2C%20subtle%20texture%20visible&width=400&height=500&seq=cat-04&orientation=portrait"
              alt="Jackets"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-white text-xs md:text-sm font-medium">Jackets</span>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com/search-915/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative h-[160px] rounded-xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20casual%20pants%20and%20shorts%20on%20light%20wooden%20surface%2C%20soft%20natural%20lighting%2C%20simple%20folded%20arrangement%2C%20warm%20cream%20background%2C%20editorial%20catalog%20style%2C%20gentle%20atmosphere&width=400&height=500&seq=cat-05&orientation=portrait"
              alt="Pants / Shorts"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-white text-xs md:text-sm font-medium">Pants / Shorts</span>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com/search-916/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative h-[160px] rounded-xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20stylish%20caps%20and%20hats%20on%20clean%20white%20surface%2C%20soft%20natural%20daylight%2C%20simple%20elegant%20arrangement%2C%20warm%20neutral%20tone%2C%20editorial%20fashion%20accessories%20photography%2C%20airy%20background&width=400&height=500&seq=cat-06&orientation=portrait"
              alt="Headwear"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-white text-xs md:text-sm font-medium">Headwear</span>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com/search-917/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative h-[160px] rounded-xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20matching%20fashion%20sets%20on%20light%20cream%20backdrop%2C%20soft%20studio%20lighting%2C%20coordinated%20outfit%20layout%2C%20warm%20neutral%20aesthetic%2C%20editorial%20lifestyle%20catalog%2C%20premium%20quality%20feel&width=400&height=500&seq=cat-07&orientation=portrait"
              alt="Sets"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-white text-xs md:text-sm font-medium">Sets</span>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com/search-918/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative h-[160px] rounded-xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20soft%20cotton%20underwear%20on%20light%20airy%20background%2C%20gentle%20natural%20daylight%2C%20simple%20neat%20folding%2C%20warm%20white%20tones%2C%20editorial%20basics%20catalog%20style%2C%20fresh%20clean%20aesthetic&width=400&height=500&seq=cat-08&orientation=portrait"
              alt="Underwear / Underpants"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-white text-xs md:text-sm font-medium">Underwear / Underpants</span>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com/search-919/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative h-[160px] rounded-xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20sports%20jersey%20on%20clean%20white%20surface%2C%20soft%20studio%20lighting%2C%20athletic%20aesthetic%2C%20warm%20neutral%20undertones%2C%20editorial%20sportswear%20catalog%20style%2C%20premium%20presentation%20feel&width=400&height=500&seq=cat-09&orientation=portrait"
              alt="Jersey"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-white text-xs md:text-sm font-medium">Jersey</span>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com/search-920/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative h-[160px] rounded-xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20fashion%20accessories%20scattered%20artistically%20on%20light%20marble%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20palette%2C%20editorial%20flatlay%20style%2C%20premium%20aesthetic%2C%20clean%20airy%20atmosphere&width=400&height=500&seq=cat-10&orientation=portrait"
              alt="Accessories"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-white text-xs md:text-sm font-medium">Accessories</span>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com/search-921/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative h-[160px] rounded-xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20stylish%20bags%20on%20light%20cream%20backdrop%2C%20soft%20natural%20daylight%2C%20clean%20simple%20composition%2C%20warm%20earthy%20tones%2C%20editorial%20fashion%20catalog%20style%2C%20elegant%20premium%20presentation&width=400&height=500&seq=cat-11&orientation=portrait"
              alt="Bags"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-white text-xs md:text-sm font-medium">Bags</span>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com/search-922/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative h-[160px] rounded-xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20leather%20belts%20on%20light%20wooden%20surface%2C%20soft%20studio%20lighting%2C%20simple%20rolled%20arrangement%2C%20warm%20neutral%20background%2C%20editorial%20accessories%20photography%2C%20elegant%20premium%20feel&width=400&height=500&seq=cat-12&orientation=portrait"
              alt="Belts"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-white text-xs md:text-sm font-medium">Belts</span>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com/search-923/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative h-[160px] rounded-xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20perfume%20bottles%20on%20light%20marble%20surface%2C%20soft%20natural%20lighting%2C%20warm%20golden%20accents%2C%20clean%20luxurious%20aesthetic%2C%20editorial%20beauty%20catalog%20style%2C%20airy%20premium%20atmosphere&width=400&height=500&seq=cat-13&orientation=portrait"
              alt="Perfumes"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-white text-xs md:text-sm font-medium">Perfumes</span>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com/search-924/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative h-[160px] rounded-xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20various%20lifestyle%20items%20on%20light%20airy%20background%2C%20soft%20natural%20daylight%2C%20clean%20diverse%20arrangement%2C%20warm%20neutral%20aesthetic%2C%20editorial%20flatlay%20style%2C%20modern%20premium%20catalog%20feel&width=400&height=500&seq=cat-14&orientation=portrait"
              alt="Other Stuff"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <span className="text-white text-xs md:text-sm font-medium">Other Stuff</span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}